import { Waves, Smartphone } from "lucide-react";

const MobileGate = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {/* Desktop blocker — hidden on mobile */}
      <div className="hidden md:flex min-h-screen flex-col items-center justify-center bg-background px-8 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-xs uppercase tracking-[0.25em] font-bold text-primary mb-8">
          <Waves className="h-3.5 w-3.5" /> Barrelcast
        </div>

        <div className="relative mb-8">
          <div className="absolute inset-0 rounded-full bg-primary/10 blur-2xl scale-150" />
          <Smartphone className="relative h-20 w-20 text-primary" />
        </div>

        <h1 className="text-3xl font-bold text-foreground mb-3">
          Built for the beach, not the desk.
        </h1>
        <p className="text-muted-foreground max-w-sm text-base leading-relaxed mb-8">
          Barrelcast is designed for mobile. Grab your phone, check the swell,
          and get in the water.
        </p>

        <div className="rounded-2xl border border-border bg-card/60 backdrop-blur px-6 py-4 text-sm text-muted-foreground">
          📱 Open <span className="font-semibold text-foreground">barrelcast.surf</span> on your phone
        </div>
      </div>

      {/* Mobile content — hidden on desktop */}
      <div className="md:hidden">
        {children}
      </div>
    </>
  );
};

export default MobileGate;
